import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays, faLandmark } from "@fortawesome/free-solid-svg-icons";
import "./ImagePlaceholder.css";
import { useLanguage } from "./LanguageContext";

function ImagePlaceholder({ src, type, className = "", alt = "", loading = "lazy" }) {
  const { language } = useLanguage();
  const [hasImageError, setHasImageError] = useState(!src);
  const isEvent = type === "event";
  const isBlockedImageHost = typeof src === "string" && /(^|\/\/)([^/]+\.)?iv\.pl\//i.test(src);
  const label = language === "en" ? "Image unavailable" : "Zdjęcie niedostępne";

  if (hasImageError || isBlockedImageHost) {
    return (
      <div className={`image-placeholder ${isEvent ? "image-placeholder-event" : "image-placeholder-place"} ${className}`} role="img" aria-label={isEvent ? "Brak zdjęcia wydarzenia" : "Brak zdjęcia miejsca"}>
        <span className="image-placeholder-icon" aria-hidden="true">
          <FontAwesomeIcon icon={isEvent ? faCalendarDays : faLandmark} />
        </span>
        <span className="image-placeholder-label">{label}</span>
      </div>
    );
  }

  return <img className={className} src={src} onError={() => setHasImageError(true)} alt={alt} loading={loading} decoding="async" />;
}

export default ImagePlaceholder;